import styled from "styled-components";

import Img from "components/Img";

const Thumbnail = styled(Img)`
  height: 60px;
  width: 60px;
  border-radius: 50%;
  border: 4px solid white;
`;

export default Thumbnail;